import { render, staticRenderFns } from "./CustomSelectCause.vue?vue&type=template&id=0631d9dc&scoped=true&"
import script from "./CustomSelectCause.vue?vue&type=script&lang=js&"
export * from "./CustomSelectCause.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectCause.vue?vue&type=style&index=0&id=0631d9dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631d9dc",
  null
  
)

export default component.exports